import { render, staticRenderFns } from "./add_strategy_user_form.vue?vue&type=template&id=4be276fd"
import script from "./add_strategy_user_form.vue?vue&type=script&lang=js"
export * from "./add_strategy_user_form.vue?vue&type=script&lang=js"
import style0 from "./add_strategy_user_form.vue?vue&type=style&index=0&id=4be276fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports